module.exports = __webpack_public_path__ + "img/img_downtimeguaranteecard.b2b50472.png";